import React, { useEffect } from 'react'
import jwt_decode from 'jwt-decode'
import { Button } from 'primereact/button'
import useSound from 'use-sound'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import clickSoundEffect from '../../../assets/audio/click2.wav'
import { GameState } from '../../../redux/types/game'
import { getGameSelector } from './../../../redux/selectors/gameSelectors'
import { useTranslation } from 'react-i18next'
import Language from '../components/Language'
import Consent from '../components/Consent'
import * as DOMPurify from 'dompurify'
import {
  fetchGameInstructionsRequest,
  fetchGameLocalesRequest,
} from '../../../redux/actions/gameActions'
import Loading from '../../../components/Loading'
import { decodeIframeString } from '../../../utils/decodeIframeString'

const Instructions = () => {
  const {
    data: { volumeGlobal, branding, selectedLanguage, instructionsHtml },
    loading: { isLoadingInstructionsHtml },
  }: GameState = useSelector(getGameSelector)
  const { t } = useTranslation()

  const token = localStorage.getItem('tokenCityHunt') ?? ''

  const { GameId }: any = jwt_decode(token)
  const [clickSound] = useSound(clickSoundEffect, {
    volume: volumeGlobal,
  })
  const navigate = useNavigate()
  const dispatch = useDispatch()
  useEffect(() => {
    if (selectedLanguage) {
      dispatch(
        fetchGameInstructionsRequest({
          gameId: GameId,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          localeId: selectedLanguage?.id,
        }),
      )
    } else {
      dispatch(fetchGameLocalesRequest(GameId))
    }
  }, [selectedLanguage])

  const sanitizedData = (data: string) => ({
    __html: DOMPurify.sanitize(data, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: ['src', 'class', 'allowfullscreen', 'frameborder'],
    }),
  })

  const onLanguageChange = (id: number) => {
    dispatch(
      fetchGameInstructionsRequest({
        gameId: GameId,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        localeId: id,
      }),
    )
  }

  return (
    <>
      {selectedLanguage && <Consent />}
      <div className="p-3">
        <div className="flex flex-column align-items-center mb-3">
          <h2 style={{ marginBottom: '0.3rem' }}>{t('Instructions')}</h2>
          <Language onChange={onLanguageChange} />
        </div>
        {!isLoadingInstructionsHtml ? (
          <div
            style={{ overflowWrap: 'break-word' }}
            className="img-full-width ql-editor my-3"
            dangerouslySetInnerHTML={sanitizedData(
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              decodeIframeString(instructionsHtml?.html ?? '') ?? '',
            )}
          />
        ) : (
          <Loading />
        )}
        <Button
          label={t('GotIt')}
          onClick={() => {
            //   clickSound()
            navigate('/welcome')
          }}
          type="button"
          icon={
            <>
              <div
                className="p-2 p-button-icon p-button-icon-right rounded-icon-style"
                style={{
                  backgroundColor: branding?.buttonPrimary.textColor,
                }}
              >
                {/* <div className="p-2 p-button-icon p-c p-button-icon-right border-circle bg-white"> */}
              </div>
              <i
                className="pi pi-check icon-center"
                style={{
                  color: branding?.buttonPrimary.backgroundColor,
                }}
              ></i>
              {/* <ArrowRight
          color="#fff"
          // variant="Bold"
          className="icon-center"
          // className="p-button-icon p-c p-button-icon-right"
        /> */}
            </>
          }
          className="p-button-rounded mt-3 py-3 zoominleft animation-duration-1000 uppercase w-full"
          style={{
            backgroundColor: branding?.buttonPrimary.backgroundColor,
            color: branding?.buttonPrimary.textColor,
          }}
          // className="p-button-rounded w-full mt-3 zoominleft animation-duration-1000"
        />
      </div>
    </>
  )
}

export default Instructions
